export const BATCH_SETTING_ID = "batch_setting_id";
export const REPORT_RESULT_ID = "report_result_id";
export const FOLLOW_UP_RESULT_ID = "follow_up_result_id";
